const Colors = {
    "Expired":"#F94444",
    "Expiry in 1-7 Days":"#FF730E",
    "Expiry in 8-30 Days":"#DC7C24",
    "Scheduled":"#2687D7",
};

export default Colors;